// extracted by mini-css-extract-plugin
module.exports = {"container":"TournamentsNav_container__1r6JU","active":"TournamentsNav_active__2M2pF","blue":"TournamentsNav_blue__3Figd"};